import React from "react";
import {
  MDBAlert, MDBTableBody, MDBTable, MDBInput, MDBCardTitle, MDBCard, MDBBtn, MDBRow, MDBCol, MDBView, MDBMask, MDBDataTableV5
} from 'mdbreact';
import MasterPage from './master_page';
import { connect } from 'react-redux';
import { addToCard, buscarMarca, validateMatricula, searchMatricula, crearFichero, eliminarRegistros, buscarTodosLosUsuariosRegistrados, verificarActivoFiltroCurso, getCursosActivos } from '../actionCreators';
import history from '../history';
import store from '../store'
import { newFormatDate } from './librerias/herramientas'
import { List, Avatar } from 'antd';
import { Select } from 'antd';


const { Option } = Select;

const onChange = (val) => {

  buscarTodosLosUsuariosRegistrados(val);

  store.dispatch({
    type: "STATE_IDCURSO_CERRAR_REGISTRO",
    idcursoCerrar: val
  })
}

const Dashboard = ({ allDataUser, cursoActivo, activeButtonDescargar, activebuttonEliminar, activofiltroCurso }) => {
  const datatable = {
    columns: [
      {
        label: 'Nombre',
        field: 'nombre',
        width: 200,
      },
      {
        label: 'Apellido1',
        field: 'apellido1',
        width: 100,
      },
      {
        label: 'Apellido2',
        field: 'apellido2',
        width: 100,
      },
      {
        label: 'Email',
        field: 'email',
        width: 200,
      },
      {
        label: 'Telefono',
        field: 'telefono',
        width: 100,
      },
      {
        label: 'CIF Taller',
        field: 'cif',
        width: 50,
      },
      {
        label: 'Id Socio',
        field: 'id_socio',
        width: 50,
      },
      {
        label: 'Nombre Socio',
        field: 'nombre_socio',
        width: 250,
      }
    ],
    rows: (Object.keys(allDataUser).length > 0 ? allDataUser.RegistroCursos.map(item => {
      return {
        nombre: item.NOMBRE,
        apellido1: item.APELLIDO_1,
        apellido2: item.APELLIDO_2,
        email: item.EMAIL,
        telefono: item.TELEFONO,
        cif: item.CIF,
        id_socio: item.ID_SOCIO,
        nombre_socio: item.SOCIO
      }
    }) : [])
  }

  return (
    <div>
      <MasterPage />
      <div className="mt-5">
        <div className="container-fluid" >
          <div className="mt-5 pt-5">
            <MDBCard className="card-body" >
              <MDBCardTitle className="text-center">Usuarios Registrados</MDBCardTitle>

              <div className="row">
                <div className="col-md-7">
                  {cursoActivo !== undefined ?
                    Object.keys(cursoActivo).length > 0 ?
                      <Select
                        showSearch
                        style={{ width: "100%", textAlign: 'left', marginTop: '10px' }}
                        placeholder="Selecciona tu curso"
                        optionFilterProp="children"
                        size={"large"}
                        onChange={(e) => { onChange(e) }}
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {cursoActivo.map((item) =>
                          <Option value={item.ID}>{item.NOMBRE}</Option>
                        )}

                      </Select>
                      :
                      null
                    :
                    null}
                </div>

                <div className="col-md-1">
                  <div className="custom-control custom-checkbox" style={{ marginTop: '20px' }}>
                    <input checked={activofiltroCurso} type="checkbox" className="custom-control-input" id="chkFitro" onClick={(e) => {store.dispatch(verificarActivoFiltroCurso(e)); getCursosActivos(); }} />
                    <label className="custom-control-label" style={{ textAlign: 'initial' }} htmlFor="chkFitro">Activo</label>
                  </div>
                </div>

                <div className="col-md-2"><MDBBtn disabled={activeButtonDescargar} color="indigo" onClick={() => crearFichero()}> Descargar</MDBBtn></div>
                <div className="col-md-2"> <MDBBtn disabled={activebuttonEliminar} color="danger" onClick={() => eliminarRegistros()}>Cerrar registro</MDBBtn></div>
              </div>

              <div className="col-md-12">
                <MDBDataTableV5 hover responsive entriesOptions={[10, 20, 25]} entries={10} pagesAmount={4} data={datatable} fullPagination />
              </div>
            </MDBCard>
          </div>
        </div>
      </div>
    </div>
  );
}


const mapStateToProps = state => {
  return {
    allDataUser: state.allDataUser,
    cursoActivo: state.cursoActivo,
    activeButtonDescargar: state.activeButtonDescargar,
    activebuttonEliminar: state.activebuttonEliminar,
    activofiltroCurso: state.activofiltroCurso
  };
}

export default connect(mapStateToProps)(Dashboard);

